import { useContext, useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Divider,
  IconButton,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import {
  CloudUpload,
  NoteAddOutlined,
  Summarize,
  ExpandMore,
  Send,
  Visibility,
} from "@mui/icons-material";
import DatePicker from "../../../../Components/Common/Inputs/DatePicker";
import { CustomButtonPlusIcon } from "../../../../Components/Common/Design/CustomButtonPlusIcon";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { encodeS3Path, getS3Url } from "../../../../Components/helpers/Helpers";
import api from "../../../../api/axios";
import { PermissionContext } from "../../../../Components/Context/Context";
dayjs.locale("es"); //  establece español como idioma por defecto

const Solicitud = ({
  dataCase,
  mailTemplatesData,
  activeTask,
  nextTask,
  activeFlow,
  caseId,
  userLogged,
  setUpdatedCase,
  updatedCase,
  docsChangedFlag,
  setDocsChangedFlag,
}) => {
  const { can } = useContext(PermissionContext);

  const [presentationDate, setPresentationDate] = useState(dayjs());
  const [message, setMessage] = useState(activeTask?.message || "");
  const [solicitudes, setSolicitudes] = useState(null);
  const [solCollapsed, setSolCollapse] = useState(false);
  const [solicitudDocumentName, setSolicitudDocumentName] = useState(
    "Solicitud de " + activeFlow?.status_name,
  );
  const [uploadedFiles, setUploadedFiles] = useState([]);

  useEffect(() => {
    try {
      let sol =
        activeTask?.config?.solicitud &&
        Object.keys(activeTask.config.solicitud).length > 0
          ? activeTask.config.solicitud
          : null;

      setSolicitudes(sol);
      setSolCollapse(sol ? true : false);
    } catch (e) {
      console.error("Error parsing config", e);
    }
  }, [activeTask]);

  const handleSolicitud = async () => {
    if (
      solicitudDocumentName !== "" &&
      presentationDate &&
      uploadedFiles.length > 0
    ) {
      try {
        const formData = new FormData();
        formData.append("case_id", Number(caseId));
        formData.append("user_id", userLogged.id);
        formData.append("folder", "Sin Carpeta");
        formData.append("flag_name", true);
        formData.append(
          "doc_desc",
          "Presentado  " + dayjs(presentationDate).format("DD/MM/YYYY HH:mm"),
        );

        uploadedFiles.forEach((file) => {
          const ext = file.name.split(".").pop();
          const newName = `${solicitudDocumentName}.${ext}`;
          const renamedFile = new File([file], newName, { type: file.type });

          formData.append("files[]", renamedFile);
        });

        const urlUpload = `${process.env.REACT_APP_API_URL}/s3/store`;

        Swal.fire({
          title: "Subiendo archivos...",
          text: "Por favor espera mientras procesamos los documentos.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const response = await api.post(urlUpload, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        console.log(response);

        if (!response?.data || !response?.data?.paths[0]) {
          throw new Error("Error en la subida de archivos");
        }

        //  Guardar la URL real del archivo subido
        const filePath = response?.data?.paths[0];
        const fileUrl = filePath.split("Sin Carpeta/")[1];

        const config = {
          ...(activeTask.config ? activeTask.config : {}),
          solicitud: {
            date: presentationDate,
            file: fileUrl,
          },
        };

        const newMessage =
          `<div class="feed-element"><div><span class="label label-info pull-right">${dayjs().format(
            "DD/MM/YYYY HH:mm",
          )}</span><hr><strong>Solicitud presentada el  ${dayjs(
            presentationDate,
          ).format("DD/MM/YYYY HH:mm")}</strong></div></div>`.replace(
            /\n\s*/g,
            "",
          );

        let fullMessage = activeTask?.message
          ? newMessage + message
          : newMessage;

        const formDataTask = new FormData();
        formDataTask.append("current_task", activeTask?.id);
        formDataTask.append("config", JSON.stringify(config));
        formDataTask.append("message", fullMessage);

        const urlUpdate = `${process.env.REACT_APP_API_URL}/casestasks/updatetasks`;
        await api.post(urlUpdate, formDataTask);

        Swal.fire({
          title: "Éxito",
          text: "Los archivos fueron subidos y la tarea se actualizó correctamente.",
          icon: "success",
          confirmButtonText: "Finalizar",
          confirmButtonColor: "#1ab394",
        });

        setUpdatedCase(!updatedCase);
        setDocsChangedFlag(!docsChangedFlag);
      } catch (error) {
        console.error(error);

        Swal.fire({
          title: "Error",
          text: "Ocurrió un problema durante la subida o actualización. Intenta de nuevo.",
          icon: "error",
          confirmButtonColor: "#d33",
        });
      }
    } else {
      Swal.fire({
        title: "Error",
        text: "Debe agregar | fecha | nombre | documento | a la solicitud",
        icon: "error",
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Volver",
      });
    }
  };

  return (
    <Grid
      container
      item
      xl={5.8}
      lg={5.5}
      md={12}
      p={1}
      sx={{ display: "block" }}>
      <Grid item xs={12}>
        <Alert
          severity="info"
          icon={<Summarize />}
          sx={{ fontWeight: "700", height: "45px" }}>
          SOLICITUDES
        </Alert>
      </Grid>

      {/* Panel ya cargado */}
      {solicitudes && (
        <Grid container>
          <Card
            sx={{
              width: "100%",
              background: "#f5f9ff",
              border: "1px solid #0073ff30",
              borderRadius: "4px",
              boxShadow: 3,
              margin: "10px",
            }}>
            <CardHeader
              avatar={<Send sx={{ color: "#0073ff" }} />}
              title={
                <div
                  style={{
                    fontWeight: 600,
                    display: "flex",
                    justifyContent: "space-between",
                  }}>
                  <Typography variant="body2">Última solicitud</Typography>

                  <Typography variant="body2">
                    {solicitudes?.date
                      ? dayjs(solicitudes.date).format("DD/MM/YYYY HH:mm")
                      : ""}
                  </Typography>
                </div>
              }
              sx={{ backgroundColor: "#005ccc31" }}
            />
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2">
                La <strong>solicitud {activeFlow?.status_name}</strong> ha sido
                presentada el{" "}
                <strong>
                  {solicitudes?.date
                    ? dayjs(solicitudes?.date).format("DD/MM/YYYY HH:mm")
                    : ""}
                </strong>
                .
              </Typography>
              {solicitudes?.file && (
                <IconButton
                  component="a"
                  href={`${process.env.REACT_APP_S3_API_URL}/${encodeS3Path(
                    "cases/" + caseId + "/" + "Sin Carpeta/" + solicitudes.file,
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  color="primary"
                  size="small">
                  <Visibility color="info" />
                </IconButton>
              )}
            </CardContent>
          </Card>
        </Grid>
      )}

      {/* Accordion */}
      {can("cases", "docs") && (
        <Accordion
          expanded={!solCollapsed}
          onChange={() => setSolCollapse(!solCollapsed)}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            sx={{
              background: "#0073ff",
              textAlign: "center",
              color: "white",
              fontWeight: "700",
              maxHeight: "38px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "38px",
              width: "100%",
              "&.Mui-expanded": {
                minHeight: "38px",
                background: "#005dcc",
              },
              "& .MuiAccordionSummary-content": {
                margin: 0,
              },
            }}>
            ADJUNTAR SOLICITUD
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              container
              sx={{
                "& > *": { padding: "10px" },
                background: "#f4f9ff",
                border: "1px dashed #f4f9ff",
              }}>
              <Grid item xs={12}>
                <b>
                  Adjuntar la solicitud presentada a los organismos oficiales.
                </b>
              </Grid>
              <Grid
                container
                sx={{
                  alignContent: "flex-start",
                  display: "flex",
                  gap: "10px",
                }}>
                <Grid item xs={12}>
                  <DatePicker
                    color={"primary"}
                    text="Fecha de presentación"
                    date={presentationDate}
                    onChange={(newValue) => {
                      setPresentationDate(newValue);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    sx={{ fontSize: "14px" }}
                    label="Solicitud informes médicos actualizados"
                    variant="outlined"
                    value={solicitudDocumentName}
                    onChange={(e) => setSolicitudDocumentName(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<CloudUpload />}
                    color="info"
                    fullWidth>
                    Cargar archivo
                    <input
                      type="file"
                      hidden
                      onChange={(event) => {
                        const files = Array.from(event.target.files);
                        setUploadedFiles((prev) => [...prev, ...files]); //  acumula archivos, no los borra
                      }}
                    />
                  </Button>

                  {uploadedFiles.length > 0 ? (
                    uploadedFiles.map((file, index) => (
                      <Typography
                        sx={{ textAlign: "center" }}
                        variant="body2"
                        key={index}>
                        {file.name}
                      </Typography>
                    ))
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{
                        color: "red",
                        marginTop: "8px",
                        textAlign: "center",
                      }}>
                      No se ha seleccionado un documento
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12} py={"10px"}>
                  <Divider width={"100%"} />
                </Grid>
                <Grid item xs={12} sx={{ textAlign: "end" }}>
                  <CustomButtonPlusIcon
                    handleFunction={handleSolicitud}
                    text={"Adjuntar solicitud"}
                    icon={NoteAddOutlined}
                    position={"start"}
                    variant={"contained"}
                    color={"info"}
                    size={"small"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}
    </Grid>
  );
};

export default Solicitud;
